import React from 'react';
import { Box, Typography, Card, CardContent, CardHeader } from '@mui/material';
import { TemplateSection } from '../../_types';
import { filterActiveFields } from '../../_utils/templateFilters';
import { neutral } from '_lex/_foundations/phxColors';
import TemplateFieldPreview from './TemplateFieldPreview';

interface TemplateSectionPreviewProps {
  section: TemplateSection;
  isInteractive?: boolean;
}

const TemplateSectionPreview: React.FC<TemplateSectionPreviewProps> = ({ section, isInteractive = false }) => {
  const activeFields = filterActiveFields(section.sectionFields || []);

  return (
    <Card
      sx={{
        border: '1px solid',
        borderColor: neutral[200],
        boxShadow: 'none',
      }}
    >
      <CardHeader
        title={
          <Typography variant='h6'>
            {section.effectiveName || section.name || 'Unnamed Section'}
            {!section.effectiveIsRequired && (
              <Typography
                component='span'
                variant='h6'
                color='text.secondary'
              >
                {' (Optional)'}
              </Typography>
            )}
          </Typography>
        }
        sx={{
          backgroundColor: neutral[50],
          borderBottom: `1px solid ${neutral[200]}`,
          p: 4,
        }}
      />
      <CardContent sx={{ p: 3 }}>
        {section.effectiveDescription && (
          <Box sx={{ mb: 3 }}>
            <Typography
              variant='body2'
              color='text.secondary'
            >
              {section.effectiveDescription}
            </Typography>
          </Box>
        )}
        {activeFields.length > 0 ? (
          <Box sx={{ display: 'grid', gap: 3 }}>
            {activeFields.map((field) => (
              <TemplateFieldPreview
                key={field.id}
                field={field}
                isInteractive={isInteractive}
              />
            ))}
          </Box>
        ) : (
          <Box sx={{ p: 3, textAlign: 'center' }}>
            <Typography
              variant='body2'
              color='text.secondary'
            >
              No fields in this section
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default TemplateSectionPreview;
